import React from 'react';
import converter from 'number-to-words';
import classNames from 'classnames/bind';
import {
  DashboardTwoTone,
  FileTextTwoTone,
  BellTwoTone,
  ExperimentTwoTone,
  FilterTwoTone,
  TeamOutlined,
  TagsTwoTone,
  QuestionCircleTwoTone
} from '@ant-design/icons';

const ZIGNAL_BASE_LINK = 'https://zignallabs.com/';
const FRESHDESK_BASE_LINK = 'https://zignallabs.freshdesk.com/en/support/solutions/articles';

export const DASHBOARDS_LINK = `${FRESHDESK_BASE_LINK}/24000078265-dashboards`;
export const REPORTS_LINK = `${FRESHDESK_BASE_LINK}/24000069863-reports`;
export const ALERTS_LINK = `${FRESHDESK_BASE_LINK}/24000070015-alerts`;
export const MQS_LINK = `${FRESHDESK_BASE_LINK}/24000079397-media-quality-score`;
export const SMART_FILTERS_LINK = `${FRESHDESK_BASE_LINK}/24000076162-smart-filter`;
export const ISSUES_LINK = `${FRESHDESK_BASE_LINK}/24000074920-issues`;
export const GROUPS_LINK = `${FRESHDESK_BASE_LINK}/24000076967-groups`;
export const HELP_LINK = 'https://zignallabs.freshdesk.com/support/home';

const trunctatedTitle = (text) => {
  if (!text || typeof text !== 'string') {
    return '';
  }
  const length = 30;
  const ellipsis = text.length > length ? ' ...' : '';
  return text.substring(0, Math.min(length,text.length)) + ellipsis;
};
// Applicable to Reports and Dashboards, not Alerts.
const getCardDescription = (typeOfCard, itemsSize) => {
  // Single item implies Default Report/Dashboard.
  if(itemsSize === 1) {
    return `You haven't created any ${typeOfCard}s yet! Check out the Workspace Default ${typeOfCard}`;
  }
  return `Here is the Workspace Default ${typeOfCard} and ${itemsSize === 2 ?
    `your most recently updated ${typeOfCard}:` :
    `your ${converter.toWords(itemsSize - 1)} most recently updated ${typeOfCard}s:`}`;
};

const getDashboardCard = (dashboards) => {
  const dashboardItems = dashboards.map((dashboard) => {
    return {
      label: trunctatedTitle(dashboard.title),
      url: dashboard.id ? `/dashboard/${dashboard.id}/`: '/dashboard/',
      type: dashboard.type || ''
    };
  });

  return {
    label: 'Dashboards',
    type: 'Dashboards',
    description: getCardDescription('Dashboard', dashboardItems.length),
    items: dashboardItems,
    bottom: {
      label: 'What\'s a Dashboard?',
      link: DASHBOARDS_LINK
    }
  };
};

const getReportCard = (reports) => {
  let reportItems;
  reportItems = reports.map((report) => {
    return {
      label: trunctatedTitle(report.title),
      url: report.id ? `/report/${report.id}/`: '/report/',
      type: report.type || ''
    };
  });

  return {
    label: 'Reports',
    type: 'Reports',
    description: getCardDescription('Report', reportItems.length),
    defaultDashboard: true,
    items: reportItems,
    bottom: {
      label: 'What\'s a Report?',
      link: REPORTS_LINK
    }
  };
};

const getAlertCard = (alerts) => {
  const alertItems = alerts.map((alert) => {
    return {
      label: trunctatedTitle(alert.label),
      url: `/alerts/edit/${alert.id}/`
    };
  });
  return {
    label: 'Alert Rules',
    type: 'Alert Rules',
    description: alertItems.length === 1 ?
      'Here is your most recently updated Alert Rule:' :
      `Here are your ${converter.toWords(alertItems.length)} most recently updated Alert Rules:`,
    items: alertItems,
    bottom: {
      label: 'What\'s an Alert Rule?',
      link: ALERTS_LINK
    }
  };
};

export const getQuickLinks = (dashboards, reports, alerts, isRestrictedUser) => {
  return [
    getDashboardCard(dashboards),
    getReportCard(reports),
    getAlertCard(alerts)
  ].map((obj) => {
    // hide any dashboards/reports/alerts if user is detect only
    obj.items = isRestrictedUser ? [] : obj.items;
    return obj;
  });
};

export const getHomeCardClasses = (styles, extendHeight, extendWidth) => {
  const cx = classNames.bind(styles);
  return {
    wrapperClass: cx({
      CardWrapper: true,
      CardWrapperWidth: !extendWidth,
      CardWrapperWidthExtended: extendWidth,
      CardWrapperHeight: !extendHeight,
      CardWrapperHeightExtended: extendHeight
    }),
    containerClass: cx({
      CardContainer: true,
      CardContainerWidth: !extendWidth,
      CardContainerWidthExtended: extendWidth,
      CardContainerHeight: !extendHeight,
      CardContainerHeightExtended: extendHeight
    })
  };
};
